(function () {
  'use strict';

  var dataEl = document.getElementById('perso-data');
  if (!dataEl) return;
  var data = JSON.parse(dataEl.textContent);
  var variants = data.variants || [];

  // ── URL params from product page ──
  var urlParams = new URLSearchParams(window.location.search);
  var prefill = {
    product: urlParams.get('product') || '',
    title: urlParams.get('title') || '',
    image: urlParams.get('image') || ''
  };

  // ── State ──
  var state = {
    size: '',
    hasText: false,
    customText: '',
    variantId: null,
    price: 0
  };

  // ── Helpers ──
  function $(id) { return document.getElementById(id); }
  function setText(id, val) { var el = $(id); if (el) el.textContent = val || '—'; }

  function findVariant() {
    var textOpt = state.hasText ? 'Oui' : 'Non';
    for (var i = 0; i < variants.length; i++) {
      if (variants[i].option1 === state.size && variants[i].option2 === textOpt) {
        return variants[i];
      }
    }
    return null;
  }

  function formatPrice(cents) {
    return (cents / 100).toFixed(2).replace('.', ',') + ' €';
  }

  function updateRecap() {
    setText('recap-illus', prefill.title);
    setText('recap-size', state.size);
    setText('recap-text', state.hasText ? (state.customText || '(à saisir)') : 'Non');

    var v = findVariant();
    if (v) {
      state.variantId = v.id;
      state.price = v.price;
      setText('recap-price', formatPrice(v.price));
    } else {
      state.variantId = null;
      setText('recap-price', '—');
    }

    $('add-to-cart').disabled = !(state.size && state.variantId);
  }

  // ── STEP 1: Size chips ──
  var sizeContainer = $('size-chips');
  sizeContainer.querySelectorAll('.perso__chip').forEach(function (chip) {
    chip.addEventListener('click', function () {
      var prev = sizeContainer.querySelector('.perso__chip--active');
      if (prev) prev.classList.remove('perso__chip--active');
      chip.classList.add('perso__chip--active');
      state.size = chip.dataset.value;
      updateRecap();
    });
  });

  // ── STEP 2: Custom text ──
  var msgCheckbox = $('add-message');
  var msgInput = $('custom-text');

  msgCheckbox.addEventListener('change', function () {
    state.hasText = this.checked;
    msgInput.style.display = this.checked ? '' : 'none';
    msgInput.disabled = !this.checked;
    if (!this.checked) {
      state.customText = '';
      msgInput.value = '';
    }
    updateRecap();
  });

  msgInput.addEventListener('input', function () {
    state.customText = this.value;
    updateRecap();
  });

  // ── Add to cart ──
  $('add-to-cart').addEventListener('click', function () {
    var btn = this;
    if (!state.variantId) return;

    btn.disabled = true;
    btn.querySelector('span').textContent = 'Ajout en cours...';

    var properties = {
      'Illustration': prefill.title
    };
    if (state.hasText && state.customText) properties['Texte'] = state.customText;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        items: [{
          id: state.variantId,
          quantity: 1,
          properties: properties
        }]
      })
    })
    .then(function (r) {
      if (!r.ok) throw new Error('Erreur ajout panier');
      return r.json();
    })
    .then(function () {
      var alert = $('cart-alert');
      alert.className = 'perso__alert perso__alert--success';
      alert.textContent = 'Votre affiche sur mesure a été ajoutée au panier !';
      alert.style.display = '';
      btn.querySelector('span').textContent = 'Ajouté !';
      setTimeout(function () {
        btn.disabled = false;
        btn.querySelector('span').textContent = 'Ajouter au panier';
      }, 2000);
    })
    .catch(function (err) {
      var alert = $('cart-alert');
      alert.className = 'perso__alert perso__alert--error';
      alert.textContent = 'Erreur : ' + err.message;
      alert.style.display = '';
      btn.disabled = false;
      btn.querySelector('span').textContent = 'Ajouter au panier';
    });
  });

  // ── Show/hide based on URL params ──
  var selectedBlock = $('selected-product');
  var noProductBlock = $('no-product');
  var stepsBlock = $('perso-steps');

  if (!prefill.product || !prefill.title) {
    noProductBlock.style.display = '';
    selectedBlock.style.display = 'none';
    stepsBlock.style.display = 'none';
  } else {
    noProductBlock.style.display = 'none';
    selectedBlock.style.display = '';
    stepsBlock.style.display = '';

    if (prefill.image) {
      $('selected-img').src = prefill.image;
      $('selected-img').alt = prefill.title;
    }
    $('selected-title').textContent = prefill.title;
    $('selected-link').href = '/products/' + prefill.product;
  }

  // Init
  updateRecap();

  // Scroll reveal
  var steps = document.querySelectorAll('.perso__step');
  if ('IntersectionObserver' in window) {
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('perso__step--visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15 });
    steps.forEach(function (s) { observer.observe(s); });
  } else {
    steps.forEach(function (s) { s.classList.add('perso__step--visible'); });
  }
})();
